<template>
  <CountrySwitcher :config="config" />
</template>

<script>
import CountrySwitcher from "../../components/CountrySwitcher/CountrySwitcher.vue";

export default {
  name: "app",
  components: {
    CountrySwitcher
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
